const menu = document.querySelector('.menu');
if (menu) {
  attachEvent('.menu__arrow', 'click', (ev) => {
    const parent = ev.target.closest('.menu__item');
    parent.classList.toggle('is-open-submenu');
    const dropdown = parent.querySelector('.menu__dropdown');
    slideToggle(dropdown, 300, 'block');
  });
}
